// Performance monitoring and Core Web Vitals tracking
export const measureWebVitals = () => {
  // Only run in production and if APIs are available
  if (process.env.NODE_ENV !== 'production' || typeof window === 'undefined') {
    return;
  }

  // Measure LCP (Largest Contentful Paint)
  const measureLCP = () => {
    new PerformanceObserver((list) => {
      const entries = list.getEntries();
      const lastEntry = entries[entries.length - 1];
      // console.log('LCP:', lastEntry.startTime, 'ms');
      
      // Send to analytics if needed
      if (window.gtag) {
        window.gtag('event', 'LCP', {
          custom_parameter: lastEntry.startTime
        });
      }
    }).observe({ entryTypes: ['largest-contentful-paint'] });
  };

  // Measure FID (First Input Delay)
  const measureFID = () => {
    new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        // console.log('FID:', entry.processingStart - entry.startTime, 'ms');
        
        if (window.gtag) {
          window.gtag('event', 'FID', {
            custom_parameter: entry.processingStart - entry.startTime
          });
        }
      }
    }).observe({ entryTypes: ['first-input'] });
  };

  // Measure CLS (Cumulative Layout Shift)
  const measureCLS = () => {
    let clsValue = 0;
    let clsEntries = [];

    new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (!entry.hadRecentInput) {
          clsValue += entry.value;
          clsEntries.push(entry);
        }
      }
      // console.log('CLS:', clsValue);
      
      if (window.gtag) {
        window.gtag('event', 'CLS', {
          custom_parameter: clsValue
        });
      }
    }).observe({ entryTypes: ['layout-shift'] });
  };

  // Measure TTFB (Time to First Byte)
  const measureTTFB = () => {
    new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        // console.log('TTFB:', entry.responseStart - entry.requestStart, 'ms');
      }
    }).observe({ entryTypes: ['navigation'] });
  };

  // Initialize all measurements
  if ('PerformanceObserver' in window) {
    measureLCP();
    measureFID();
    measureCLS();
    measureTTFB();
  }
};

// Resource loading optimization
export const optimizeResourceLoading = () => {
  // Preload critical resources
  const preloadCriticalImages = () => {
    const criticalImages = [
      '/images/The-Random-Store---Logo---Transparent - Copy.png',
      '/images/favicon.ico'
    ];

    criticalImages.forEach(src => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = src;
      document.head.appendChild(link);
    });
  };

  // Defer non-critical scripts
  const deferNonCriticalScripts = () => {
    const scripts = document.querySelectorAll('script[src]');
    scripts.forEach(script => {
      if (!script.hasAttribute('defer') && !script.hasAttribute('async')) {
        script.defer = true;
      }
    });
  };

  preloadCriticalImages();
  deferNonCriticalScripts();
};

// Initialize performance optimizations
export const initPerformanceOptimizations = () => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      optimizeResourceLoading();
      measureWebVitals();
    });
  } else {
    optimizeResourceLoading();
    measureWebVitals();
  }
};
